var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#FFD2DB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2160_18774)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1511 23.0766C29.8209 23.0766 29.5533 23.3442 29.5533 23.6743V28.9815C29.5522 29.9714 28.7501 30.7737 27.7602 30.7746H10.9886C9.99864 30.7737 9.19662 29.9714 9.19545 28.9815V13.4054C9.19662 12.4156 9.99864 11.6134 10.9886 11.6122H16.2958C16.6259 11.6122 16.8935 11.3446 16.8935 11.0145C16.8935 10.6846 16.6259 10.4167 16.2958 10.4167H10.9886C9.33881 10.4186 8.00187 11.7556 8 13.4054V28.9817C8.00187 30.6315 9.33881 31.9684 10.9886 31.9703H27.7602C29.41 31.9684 30.7469 30.6315 30.7488 28.9817V23.6743C30.7488 23.3442 30.4812 23.0766 30.1511 23.0766Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.512 8.8789C29.4616 7.82845 27.7585 7.82845 26.7081 8.8789L16.0443 19.5427C15.9712 19.6158 15.9184 19.7064 15.8909 19.8058L14.4886 24.8685C14.4309 25.0761 14.4895 25.2983 14.6417 25.4508C14.7942 25.603 15.0165 25.6616 15.2241 25.6042L20.2867 24.2017C20.3862 24.1741 20.4768 24.1213 20.5499 24.0483L31.2134 13.3843C32.2622 12.3331 32.2622 10.6315 31.2134 9.5803L30.512 8.8789ZM17.3467 19.9312L26.0742 11.2035L28.8888 14.0182L20.1611 22.7459L17.3467 19.9312ZM16.7844 21.0594L19.0332 23.3083L15.9226 24.1701L16.7844 21.0594ZM30.3682 12.539L29.7343 13.1729L26.9194 10.358L27.5535 9.72412C28.137 9.14064 29.0831 9.14064 29.6666 9.72412L30.3682 10.4255C30.9507 11.0097 30.9507 11.9551 30.3682 12.539Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2160_18774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool);
export default __webpack_public_path__ + "static/media/tool.262c0fa9df6e7d28a29d50d87f4136eb.svg";
export { ForwardRef as ReactComponent };